import getMadaiURL from '../domain/getMadaiURL';
import get_bundle from '../domain/get_bundle';

const madai_url = getMadaiURL();

export default function getConditions(locale) {
  function getHref() {
    //return "https://madai.com/privacy_us.html"
    const _locale = locale.toString();
    const country = locale.country.toLowerCase();
    if (_locale === 'en_GB') {
      return 'https://uk.madai.com/terms.html';
    } else if (_locale === 'en_US') {
      return 'https://madai.com/terms.html';
    } else if (_locale === 'it_IT') {
      return 'https://it.madai.com/terms.html';
    }
    else {
      return 'https://madai.com/terms.html';
    }
  }
  return '<a target="_blank" href="' + getHref() + '">' + get_bundle(locale).footer.conditions + '</a>';
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/getConditions.js
 **/